import script from "./Checkout.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkout.vue?vue&type=script&setup=true&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=fa1c8e28&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa1c8e28"]])

export default __exports__